export const contractStatuses = {
  own: 'EIGEN',
  application: 'ANTRAG',
};
